/* tslint:disable:typedef-whitespace no-trailing-whitespace */

import {TaskUpdate, TaskUpdateType} from "@/models/task.update";
import {basename, bytesToSize} from "@/util/util";

/**
 *
 * @class TaskUpdateFileUploadComplete
 *
 * @brief sentinel progress event; file completed its upload.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      December 2021
 *
 */
export class TaskUpdateFileUploadComplete extends TaskUpdate {


  /**  the blob key or file name being uploaded */
  public fileName: string;

  /** the icon to use for the file type */
  public icon:     string;

  /** the file size (byte count) */
  public total:    number;

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id       the unique id of the task progress stream to clear (the context)
   * @param fileName the blob key or file name being uploaded
   * @param icon     the icon to use for the file type
   * @param total    the file size (byte count)
   *
   */
  constructor(id: string, fileName: string, icon: string, total: number) {

    super(id, TaskUpdateType.Complete,100.0);

    this.fileName = fileName;
    this.icon     = icon;
    this.total    = total;

  }

  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    let label:    string = basename(this.fileName);
    let fileSize: string = bytesToSize(this.total);

    return `
<div class="task-file-upload-sub-panel">

  <div style="display: inline-block; width: 32px;">
    <img alt="uploadiing file" class="tsp-icon" src="/assets/images/blob-icons/${this.icon}" width="32"></img>
  </div>

  <div style="display: inline-block; width: calc(100% - 40px);">

    <div style="display: block;">
      <span class="tsp-label">${label}</span>
    </div>

    <div style="display: block;">
      <span class="tsp-size">[Upload] ${fileSize}</span>
    </div>

  </div>

</div>`;
  }

  /** is this task complete? */
  isComplete(): boolean {

    return true;
  }

}
